import { forwardRef } from 'react'

import { ButtonBase, ButtonBaseProps } from '@mui/material'
import { createLink } from '@tanstack/react-router'

type ButtonBaseLinkProps = Omit<ButtonBaseProps<'a'>, 'component'>

export const ButtonBaseLink = createLink(
  forwardRef<HTMLAnchorElement, ButtonBaseLinkProps>(function MUIButtonBaseLink(props, ref) {
    return <ButtonBase ref={ref} component="a" {...props} />
  }),
)
